<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="活动名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'activityName',
              {
                rules: [
                  { required: true, message: '请输入活动名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入活动名称"
          />
        </a-form-item>
        <a-form-item
          label="活动简介"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            type="text"
            :max-length="20"
            v-decorator="['activityDescribe']"
            rows="3"
            placeholder="请输入活动简介，限制20个字"
          />
        </a-form-item>
        <a-form-item
          label="活动渠道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择活动渠道"
            v-decorator="[
              'channelType',
              { rules: [{ required: true, message: '请选择活动渠道' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_channel_type"
          />
        </a-form-item>
        <a-form-item
          label="活动图片"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="[
              'activityImage',
              { rules: [{ required: true, message: '请上传图片' }] },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="活动链接地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            v-decorator="['activityUrl']"
            placeholder="请输入活动链接地址"
          />
        </a-form-item>
        <!--<a-form-item label="活动点击跳转文案" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input type="text" :max-length="10" v-decorator="['activityJumpRemark']" placeholder="请输入活动点击跳转文案,限制10个字"/>
        </a-form-item>-->
        <a-form-item
          label="是否发奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="isAward"
            @change="changeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'prizeSource',
              { rules: [{ required: true, message: '请选择奖品来源' }] },
            ]"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandle"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="isAward"
          label="奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'relevancePrize',
              { rules: [{ required: true, message: '请选择奖品' }] },
            ]"
            placeholder="请选择奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--<a-form-item label="启用状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag placeholder="请选择启用状态" v-decorator="['status', { rules: [{ required: true, message: '请选择启用状态' }] }]" :triggerChange="true" dictCode="obj_status"/>
        </a-form-item>-->
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="sortIndex"
            v-decorator="[
              'sort',
              { rules: [{ required: true, message: '请输入排序' }] },
            ]"
            placeholder="排序数字越小越靠前"
            type="number"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
// import JImageUpload from '@/components/jeecg/JImageUpload';
import { getAction } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'GoldMallActivityModal',
  components: {
    JDate,
    // JImageUpload,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      isAward: false, //是否发奖开关，默认关闭状态
      //showPrizeList: false,//奖品列表，默认隐藏
      prizesList: [], //奖品列表
      prizeSourceList: [
        {
          name: '奖品库',
          value: 1,
        },
        {
          name: '积分库',
          value: 2,
        },
      ], //奖品来源

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/gold/marketing/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      if (record.isAward === 1) {
        this.isAward = true;
      } else {
        this.isAward = false;
      }
      this.prizeSourceHandle(record.prizeSource);
      this.fileList = record.activityImage;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      console.log(record.activityImage);
      this.$nextTick(() => {
        this.form.setFieldsValue({
          activityImage: record.activityImage
            ? process.env.VUE_APP_FILE_PATH + record.activityImage
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'sort',
            'activityName',
            'channelType',
            // 'activityImage',
            'activityDescribe',
            'activityUrl',
            'isAward',
            'prizeSource',
            'relevancePrize'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.isAward = that.isAward === true ? '1' : '0';
          formData.activityImage = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'sort',
          'activityName',
          'activityImage',
          'channelType',
          'activityDescribe',
          'activityUrl',
          'isAward',
          'prizeSource',
          'relevancePrize'
        )
      );
    },
    receiveTypesValue(e) {},

    changeHandler(e) {
      this.isAward = e;
    },

    prizeSourceHandle(e) {
      this.prizesList = [];
      this.form.setFieldsValue({
        //《=关键 清空tag选项
        relevancePrize: [],
      });
      if (e === 1 || e === 2) {
        this.getPrizesList(e);
      }
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === 1) {
        getUrl = this.url.getPrizeList;
      } else if (type === 2) {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === 2) {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        activityImage: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
